import styled from 'styled-components'
import { DARK_VIOLET, GRAYSCALE_50, GRAYSCALE_BORDER } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
`

export const IconContainer = styled.div`
  background-color: ${GRAYSCALE_50};
  border: 1px solid ${GRAYSCALE_BORDER};
  border-radius: 12px;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ProviderName = styled.span`
  font-family: ${INTER.regular};
  font-size: 12px;
  color: ${DARK_VIOLET};
`
